<header class="topbar">

  <!-- Mobile menu (hamburger) — visible only on small screens -->
  <button class="menu-toggle" type="button" (click)="toggleSidebar()" aria-label="Toggle menu">
    <i class="bi bi-list"></i>
  </button>

  <!-- Left Section -->
  <div class="topbar-left">
    <!-- <h2 class="page-title">{{ currentPage | titlecase }}</h2> -->
  </div>

  <!-- Nav Links -->
  <nav class="topbar-nav">
    <a href="https://lex-z.ai/">Find Lawyers</a>
    <a href="https://lex-z.ai/video-consultation/">Video Consultation</a>
    <a href="https://lex-z.ai/credential-validation/">Credential Validation</a>
    <a href="https://lex-z.ai/products/">Products</a>
    <a href="https://lex-z.ai/blogs/">Resources</a>
    <!-- <a routerLink="/appointments" routerLinkActive="active-nav">My Appointments</a> -->
  </nav>

  <!-- Right Section -->
  <div class="topbar-right">
    <div class="user-profile">
      <div class="avatar-wrapper" (click)="toggleProfileMenu()">
        <img *ngIf="profileImg" [src]="profileImg" [alt]="profileData?.first_name" class="avatar" />
        <div class="avatar-text" *ngIf="!profileImg">
          {{ profileData?.first_name?.charAt(0)?.toUpperCase() }}
        </div>

        <!-- Hover tooltip (hidden while the detail card is open) -->
        <div class="avatar-tooltip" *ngIf="!showProfileMenu">
          <span class="tooltip-name">{{ fullName }}</span>
          <span class="tooltip-email">{{ profileData?.email }}</span>
        </div>
      </div>

      <!-- Dropdown on click -->
      <div class="profile-dropdown" *ngIf="showProfileMenu">
        <button type="button" class="dropdown-close" (click)="showProfileMenu=false" aria-label="Close">
          <i class="bi bi-x"></i>
        </button>
        <div class="dropdown-user-info">
          <span class="dropdown-name">{{ fullName }}</span>
          <span class="dropdown-email">{{ profileData?.email }}</span>
        </div>
        <div class="dropdown-divider"></div>
        <a routerLink="/consumer/settings" (click)="showProfileMenu=false">
          <i class="bi bi-gear"></i> Profile Settings
        </a>
        <div class="dropdown-divider"></div>
        <a routerLink="/consumer/appointments" (click)="showProfileMenu=false">
          <i class="bi bi-calendar-check"></i> My Appointments
        </a>
      </div>
    </div>
  </div>

</header>